import React from 'react'
import { AccordionItem, AccordionItemBody, AccordionItemTitle } from "react-accessible-accordion"

import TranslatedText from "../../TranslatedText"
import {__} from "../../../services/i18n"

const RecoveryTimeAccordionItem = () => (
    <AccordionItem>
        <AccordionItemTitle>
            <h3>{__('procedure_other:accordion_2_3_heading')}</h3>
        </AccordionItemTitle>
        <AccordionItemBody>
            <p><TranslatedText translationKey="procedure_other:accordion_2_3_paragraph_1" /></p>
            <p><TranslatedText translationKey="procedure_other:accordion_2_3_paragraph_2" /></p>
            <p><TranslatedText translationKey="procedure_other:accordion_2_3_paragraph_3" /></p>
        </AccordionItemBody>
    </AccordionItem>
)

export default RecoveryTimeAccordionItem
